import * as ko from 'knockout';

import { Dimension } from './dimension';
import { CropData } from '../api/crops';
import { NameI18nData } from '../api/names';
import { TraitWithCropCodesData } from '../api/measurement_metas';
import { DimensionMeta } from './dimension_meta';
import { getCropCategorySearchConfig, getMMTraitsSearchConfig } from '../components/configs/search_configs';

export class Crop extends Dimension {
  category = ko.observable<NameI18nData>(null);
  traits = ko.observableArray<TraitWithCropCodesData>(null).extend({ serverError: true });

  editUrl = ko.pureComputed(() => {
    return '/crops/' + this.id() + '/';
  });

  categorySearch = getCropCategorySearchConfig(this.category);
  traitSearch = getMMTraitsSearchConfig(this.traits);

  // Function to determine if a trait can be removed (traits for all crops cannot be removed)
  enableRemoveTrait = (trait: TraitWithCropCodesData): boolean => {
    // Empty crops array means applicable to all crops
    return trait.crop_codes.length > 0;
  };

  constructor(data?: CropData, dimensionMeta?: DimensionMeta) {
    super(data, dimensionMeta);

    if (data) {
      this.category(data.category);
      this.traits(data.traits);
    }
  }

  toData(): CropData {
    let data = <CropData>super.toData();

    data.category = this.category();
    data.traits = this.traits().filter((trait) => trait.crop_codes.length > 0);

    return data;
  }
}
